import { WorkflowQueryKeys } from './types';

/**
 * Query key factory utilities for TanStack Query
 *
 * Convention: [domain, ...identifiers, ...dependencies]
 * All keys must be deterministic and use primitive values only.
 */

export const workflowQueryKeys: WorkflowQueryKeys = {
  dates: () => ['workflow', 'dates'],
};
